import omit from '../../../Services/omit'

export default (projectId) => (dispatch) => {

  dispatch(omit(projectId))

}
